import { z } from 'zod';
import { requiredString } from '@/shared/lib/validation';
import { UserRole } from '@/core/generated/api';
import { isValidRussianPhone } from '@/shared/lib/phone';

/** Проверяет данные первого шага входа сотрудника */
export const credentialsSchema = z.object({
    phone: z.string()
        .refine(isValidRussianPhone, 'Введите полный номер телефона'),
    password: requiredString('Введите пароль', { trim: false }),
    role: z.enum([
        UserRole.SuperAdmin,
        UserRole.Admin,
        UserRole.Marketer,
        UserRole.Recruiter,
        UserRole.TechnicalSupport,
        UserRole.Custom,
    ]),
});

export type CredentialsFormValues = z.infer<typeof credentialsSchema>;

export const CREDENTIALS_FORM_DEFAULTS: CredentialsFormValues = {
    phone: '',
    password: '',
    role: UserRole.Admin,
};

/** Проверяет код подтверждения входа сотрудника */
export const verificationSchema = z.object({
    code: z.string()
        .regex(/^\d{4}$/, 'Введите четырёхзначный код'),
});

export type VerificationFormValues = z.infer<typeof verificationSchema>;

export const VERIFICATION_FORM_DEFAULTS: VerificationFormValues = {
    code: '',
};
